'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.HTMLTemplates').service("EasyFormCommonService", ['CommonService', '$base64', '$injector', 'CommonPostService', 'WebWorkerService','$q','GoogleCloudFunctionHandlerService', function (CommonService, $base64, $injector, CommonPostService, WebWorkerService, $q,GoogleCloudFunctionHandlerService) {

	//######### METHOD TO   METHOD TO GET IN BOX COUNT FOR REFERRAL EASY FORMS FILLED IN LATEST NON PROVIDER PORTAL  BLOCK START ##############
	//*******PURPOSE: This method is used to GET TOTAL LATEST PORTAL MESSAGES COUNT
	//*******CREATED BY: DURGA PRASAD V
	//*******CREATED DATE: 08/19/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.GetNonProviderPortalReferralFormsCount = function () {
		var postData = {
			practicemodel: EMRPracticeModel
		};
		return CommonService.PostData('POST', CommonService.EHR_Portal_Documents_API() + "GetNonProviderPortalReferralFormsCount", postData).then(
			function (result) {
				return result;
			});
	};
	//################### METHOD TO   METHOD TO GET IN BOX COUNT FOR REFERRAL EASY FORMS FILLED IN LATEST NON PROVIDER PORTAL  BLOCK END #########################

	//################### SAVE FILLABLE HTML TEMPLATES LOG  BLOCK START #########################
	//*******PURPOSE: This method is used for auto saving the fillable html templates auto log backup asynchronously 
	//*******CREATED BY: Mahesh P
	//*******CREATED DATE: 09/01/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatesSaveHtmlTemplateLog = function (postData) {
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.clientIP = EMRPracticeModel.clientIP;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		postData.ApplicationType = EMRPracticeModel.ApplicationType;
		postData.PortalUserType = EMRPracticeModel.PortalUserType;

		postData.practicemodel = EMRPracticeModel;


		//MAKING THE HTML STRING BASE 64 CONVERSION TO LZ STRING COMPRESSION
		if (hasValue(postData.DocumentsFillableHTMLTemplatesPatientDataBinaryFormatInBase64)) {

			var htmlstring = $base64.decode(postData.DocumentsFillableHTMLTemplatesPatientDataBinaryFormatInBase64);
			var emrcommonfactory = $injector.get('EMRCommonFactory');
			postData.DocumentsFillableHTMLTemplatesPatientDataBinaryFormatInBase64 = emrcommonfactory.compressLzString(htmlstring);
		}


		if (hasValue(postData) && hasValue(postData.htmlTemplateViewerTemplateName)) {

			postData.EasyFormTemplateName = postData.htmlTemplateViewerTemplateName;
		}
		//SPECIFYING THAT IT IS A ACTION WCF CALL
		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

		//  var savingtemplateURL = CommonService.EMRClinicalManagement_HTMLTemplates() + "SaveHtmlTemplateLog";
		//var savingtemplateURL = CommonService.EMRClinicalManagement_HTMLTemplatesEasyFormSaveLog() + "SaveHtmlTemplateLog";
		//var savingtemplateURL = CommonService.EMR_Web_WCF_EasyFormsMgnt_EasyForms() + "SaveHtmlTemplateLog";
		var savingtemplateURL = CommonService.EHR_Easyforms_API_TOP_HITS_API() + "SaveHtmlTemplateLog";
		let auditLogInsertAzureCalls = [];
		if (![...disabledAuditLogAzureCallsBasedOnPracticeID].includes(EMRPracticeModel.PracticeID)) {
			if ([999].includes(EMRPracticeModel.PracticeID)) {
				savingtemplateURL = "https://afeasyformautosavelogloc.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=evvjYTK8UVTWq-3WEnuTFuXdappKy5NPmI-pWu4gnE5tAzFuIJqwtA==";
				auditLogInsertAzureCalls = [
					{ "url": "https://afeasyformautosavelogloc.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=evvjYTK8UVTWq-3WEnuTFuXdappKy5NPmI-pWu4gnE5tAzFuIJqwtA==" },
					{ "url": "https://afeasyformautosavelogloc.azurewebsites.net/api/AFEasyFormAutoSaveLog1?code=GREI4y-2jxQ4uc5n2dxhcPL1lEjwuMuh16QL9XMgOnKIAzFu3RmR6Q==" },
					{ "url": "https://afeasyformautosavelogloc.azurewebsites.net/api/AFEasyFormAutoSaveLog2?code=tAjrJ4CEiomQUmtzir4zRW0kENAoG9j55zgCt-mvS8T4AzFuhsbo3Q==" },
				];
			}
			else {
				savingtemplateURL = "https://easyformautosaveafprod.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=StPBdyjPWsEd2ZvrXk_z1zupaig1G5ul-JVA5vgBsHY5AzFu8cpadw==";
				auditLogInsertAzureCalls = [
					{ "url": "https://easyformautosaveafprod.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=StPBdyjPWsEd2ZvrXk_z1zupaig1G5ul-JVA5vgBsHY5AzFu8cpadw==" },
					{ "url": "https://easyformautosaveafprod1.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=WsNNSpH3qOkzm5CAnq1n7Ed6ZA1ou27s4KzmUii2l4GFAzFuR1u2fw==" },
					{ "url": "https://easyformautosaveafprod2.azurewebsites.net/api/AFEasyFormAutoSaveLog?code=e88uTPxxzFHqJdxcDHuv-PoFFRcKUUeLXNwsB-qYKRF5AzFuBBMyeA==" },
				];
			}

			if (!savingtemplateURL) return $q.resolve(undefined);
			postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
			postData.ApplicationType = EMRPracticeModel.ApplicationType;
			postData.DBServerName = EMRPracticeModel.DBServerName;
			postData.LoggedUserID = EMRPracticeModel.LoggedUserID;
			postData.PracticeID = EMRPracticeModel.PracticeID;
			// UserType == 1.External Provder 2.Patient 3.Contact 4.EHR PROVIDER
			if (EMRPracticeModel.ApplicationType == 1)//ehr
				postData.UserType = 4;//ehr login
			else if (EMRPracticeModel.ApplicationType == 2)//portal
				postData.UserType = EMRPracticeModel.PortalUserType;//portal login
			var deferred = $q.defer();
			const inputmodel = {
				data: postData,
				url: savingtemplateURL,
				id: deferred,
				mailurl: CommonService.EMRWCFCallingURL(),
				isFromAzureCalls: true,
				auditLogInsertAzureCalls: auditLogInsertAzureCalls,
				navigationFrom:21,
			}

			WebWorkerService.saveEasyFormAutoSaveAuditLogInfo(inputmodel);
			return deferred.promise;
			// return CommonPostService.httpPostDataForAzureFuctions('POST', savingtemplateURL, postData);
		} 
		else {
			if (window.location.href.indexOf("localhost") > 0) {

			} else {
				//if the current url is primary then sending  the log requests through secondary
				if (savingtemplateURL.indexOf(EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL) >= 0)
					savingtemplateURL = savingtemplateURL.replace(EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL, EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL);
				else if (savingtemplateURL.indexOf(EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL) >= 0)
					savingtemplateURL = savingtemplateURL.replace(EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL, EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL);
			}



			return CommonService.PostData('POST', savingtemplateURL, postData, 5 * 60 * 1000).then(
				function (result) {
					return result;
				});
		}
	};
	//################### SAVE FILLABLE HTML TEMPLATES LOG  BLOCK END #########################

	//*******PURPOSE: THIS METHOD IS USED TO UPDATE THE FILLABLE HTML TEMPLATES INFORMATION OF EASY FORMS FROM AUDIT LOG
	//*******CREATED BY: RAVI TEJA.P
	//*******CREATED DATE: 6/14/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatesMoveEasyFormAutoSaveLogToSavedNotes = function (postData) {

		postData.ApplicationType = EMRPracticeModel.ApplicationType;
		postData.PortalUserType = EMRPracticeModel.PortalUserType;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		postData.PracticeName = EMRPracticeModel.PracticeName;
		postData.EHRJSONRequestLogEMRDateTime = adminGetCurrentDateAndTime();
		postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
		postData.FirstName = EMRPracticeModel.FirstName;
		postData.UserType = EMRPracticeModel.UserType;
		postData.LastName = EMRPracticeModel.LastName;
		postData.MiddleInitial = EMRPracticeModel.MiddleInitial;
		postData.LoggedFacilityName = EMRPracticeModel.LoggedFacilityName;
		postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;
		postData.EHREasyFormsCommonJSFileName = EMRPracticeModel.EHREasyFormsCommonJSFileName;
		postData.clientIP = EMRPracticeModel.clientIP;
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.emrurlsmodel = {
			EMRWebWCFPrimaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL,
			EMRWebWCFSecondaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL,
			EMRCentralizerSocketPrimaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketPrimaryURL,
			EMRCentralizerSocketSecondaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL,
		}
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

		return CommonService.PostData('POST', CommonService.EHR_EasyFormSave_API() + "MoveEasyFormAutoSaveLogToSavedNotes", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  UPDATE EASY FORMS FROM SAVED AUDIT LOG INFORMATION BLOCK END #########################

	//###################  GET EASY FORM SAVED NOTES SIGNED URL- BLOCK START ##############################
	/// *******PURPOSE:THIS  METHOD IS USED TO GET EASY FORM SAVED NOTES SIGNED URL- BLOCK START
	///*******CREATED BY: RAVI TEJA.P
	///*******CREATED DATE: 12/11/2017
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************   
	this.HTMLTemplateServiceGetPatientDataBinaryGCloudSignedURLS = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EasyForm_View_API() + "GetPatientDataBinaryGCloudSignedURLS", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  GET LIST OF WEB FORM TO EASY FORM FIELD MAPPING INFO LIST BLOCK END ##############################

	//###################   GETTING TEMPLATEIDS HAVING NOTES BLOCKING RULES -  BLOCK START ##############################
	/// *******PURPOSE      :THIS METHOD TO GET THE TEMPLATE IDS ARE HAVING RULES TO BLOCK
	///*******CREATED BY    : AJAY
	///*******CREATED DATE  : 11/26/2018
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************   
	this.getTemplateIdsHavingNotesBlockingRules = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_BlockingRules_API() + "GetTemplateIdsHavingNotesBlockingRules", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  GETTING TEMPLATEIDS HAVING NOTES BLOCKING RULES -  BLOCK END ##############################

	//################### GET EASY FORM LINKED NOTES BLOCKING RULES INFO BLOCK START #########################
	///*******PURPOSE           : THIS METHOD IS TO GET EASY FORM LINKED NOTES BLOCKING RULES INFO
	///*******CREATED BY        : AJAY.NANDURI
	///*******CREATED DATE      : 12/16/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.htmlTemplateServiceGetEasyFormLinkedNotesBlockingRules = function (postData) {

		// ASSIGNING THE PRACTICE MODEL TO THE INPUT DATA
		// THIS PARACTICE MODEL CONSISTS ALL THE INFO OF CURRENT USER LOGIN LINKED PRACTICE INFO
		// THIS PRACTICE MODEL CONSISTS LOGGED USER INFO
		postData.practicemodel = EMRPracticeModel;
		// CALLING THE CENTRALIZED SERVICE METHOD WHICH POST THE API REQUEST TO SAVE CUSTOMIZED FIELDS INFO
		// BY USING THE COMMON SERVICE IT GENERATES THE POST REQUEST URL WITH REQUESTED INPUT DATA
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_BlockingRules_API() + "GetEasyFormLinkedNotesBlockingRules", postData).then(
			function (result) {
				return result;
			});
	};
	//################### GET EASY FORM LINKED NOTES BLOCKING RULES INFO BLOCK END #########################

	//###################   GET EASY FORMS FORWARD DETAILS BLOCK START ##############################
	/// *******PURPOSE              : THIS METHOD IS USED TO GET EASY FORMS FORWARD DETAILS
	///*******CREATED BY            : AHMED BASHA SHAIK 
	///*******CREATED DATE          : 05/27/2019
	///*******MODIFIED DEVELOPER    : DATE - NAME - WHAT IS MODIFIED; *************************   
	this.htmlTemplatesGetEasyformForwardDetails = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_ManualForwarding_API() + "GetEasyformForwardDetailsForFieldedSaving", postData).then(
			function (result) {
				return result;
			});
	};
	//###################   GET EASY FORMS FORWARD DETAILS BLOCK END ##############################

	//###################  GET EASY FORMS CUSTOMIZATION PERMISSION LIST BLOCK START ##############################
	/// *******PURPOSE              : THIS METHOD IS USED TO GET EASY FORMS CUSTOMIZATION PERMISSION LIST
	///*******CREATED BY            : AHMED BASHA SHAIK 
	///*******CREATED DATE          : 06/24/2019
	///*******MODIFIED DEVELOPER    : DATE - NAME - WHAT IS MODIFIED; *************************   
	this.htmlTemplatesGetEasyformEditCustomizationPermissionList = function (postData) {

		// PASSING PRACTICE MODEL 
		postData.practicemodel = EMRPracticeModel;
		// PASSING WCF ACTION TYPE WHICH USED IN SHOWING LOADING GIF
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		// CALLING REST API WITH REQ PARAMETERSS
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EFEditPermissontoUsersCust_API() + "GetEasyformEditCustomizationPermissionList", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  GET EASY FORMS CUSTOMIZATION PERMISSION LIST BLOCK END ##############################

	//###################    COPY EASYFORMS BUTTONS CUSTOMIZATION FROM ONE USER TO OTHER USERS   BLOCK START ##############################
	/// *******PURPOSE          : THIS  SERVICE IS USED TO COPY EASYFORMS BUTTONS CUSTOMIZATION FROM ONE USER TO OTHER USERS 
	///*******CREATED BY        : AJAY.NANDURI
	///*******CREATED DATE      : 06-06-2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************  
	this.htmlTemplatesGetEasyFormCustomizedActionBtnsBasedOnTemplateID = function (postData) {

		// assigning the practice model
		postData.practicemodel = EMRPracticeModel;
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		// MAKE A API CALL TO GET CUSTOMIZED ACTION BUTTONS BASED ON TEMPLATE ID
		return CommonService.PostData('POST', CommonService.EHR_EFActionButtonsCust() + "GetEasyFormCustomizedActionBtnsBasedOnTemplateID", postData).then(
			function (result) {
				return result;
			});
	};
	//###################    COPY EASYFORMS BUTTONS CUSTOMIZATION FROM ONE USER TO OTHER USERS  BLOCK END ##############################

    /* This method is used to get notes hide after patientdischarge from program flag Info
     * Created By:sudheer.kommuri
     * Created On:06/05/2020
     * param {object} InputData
     * returns {object} result
     */
	this.GettingNoteshideaferPatientDischargefromProgramSettingInfo = function (InputData) {
		InputData.practicemodel = EMRPracticeModel;
		InputData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_ProgramService_API() + "GettingNoteshideaferPatientDischargefromProgramSettingInfo", InputData).then(
			function (result) {
				return result;
			});
	};

    /**
    * This Func is used to get EasyForms LKP LIST is stored in global varibale in commonfactory
    * Created By   : AjayKumar.Nanduri
    * Created On   : 13-07-2020
    * @param {any} postData
   */
	this.htmlTemplateGetEasyFormsLKPList = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_ImportEasyForms() + "GetEasyFormsLKPList", postData).then(
			function (result) {
				return result;
			});
	};

	//###################GET HTML TEMPLATES LKP BINARY BLOCK START #########################
	//*******PURPOSE: this method is used to get all available fillable html templates 
	//*******CREATED BY: George D
	//*******CREATED DATE: 09/01/2014
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmltemplatesValidateEasyFormLastModifiedDateForLLS = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_CreateNewNotes_API() + "GetEasyFormTemplateLastModifiedDateForLLS", postData).then(function (result) {
			return result;
		});
	};

	//###################  METHOD TO GET GOLDEN THREAD PROPERTY TO EASY FORM FIELD CUSTOMIZATION LIST  BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USEFUL IN GETTING GOLDEN THREAD PROPERTY TO EASY FORM FIELD CUSTOMIZATION LIST
	//*******CREATED BY: MAHESH P
	//*******CREATED DATE: 03/17/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.HTMLTemplateGetGoldenThreadCustomizationFieldList = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_GoldenThread_API() + "GetGoldenThreadCustomizationFieldList", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  METHOD TO GET GOLDEN THREAD PROPERTY TO EASY FORM FIELD CUSTOMIZATION LIST  BLOCK END #########################

	//###################  METHOD TO GET GOLDEN THREAD PROPERTY FIELDS POPULATION TO EASY FORM FIELD CUSTOMIZATION LIST  BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USEFUL IN GETTING GOLDEN THREAD PROPERTY TO EASY FORM FIELD CUSTOMIZATION LIST
	//*******CREATED BY: MAHESH P
	//*******CREATED DATE: 03/17/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.HTMLTemplateGetGoldenThreadCustomizationFieldsValuesPopulationList = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_GoldenThread_API() + "GetGoldenThreadCustomizationFieldsValuesPopulationList", postData).then(
			function (result) {

				return result;
			});
	};
	//###################  METHOD TO GET GOLDEN THREAD PROPERTY FIELDS POPULATION TO EASY FORM FIELD CUSTOMIZATION LIST  BLOCK END #########################

	//###################  UNSIGN EASY FORM VALIDATION - BLOCK START  #########################
	/// *******PURPOSE              : THIS METHOD IS USED TO UNSIGN EASY FORM VALIDATION
	///*******CREATED BY            : RAVI TEJA.P
	///*******CREATED DATE          : 2/6/2018
	///*******MODIFIED DEVELOPER    : DATE - NAME - WHAT IS MODIFIED; *************************
	this.htmlTemplateServiceValidateEasyFormUnsignOff = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_EasyFormSave_API() + "UnsignEasyFormsValidation", postData).then(
			function (result) {
				return result;
			});

	};
	//###################  UNSIGN EASY FORM VALIDATION - BLOCK END #########################

	//###################  UNSIGN EASY FORM NOTES - BLOCK START  #########################
	/// *******PURPOSE              : THIS METHOD IS USED TO UNSIGN EASY FORM NOTES
	///*******CREATED BY            : RAVI TEJA.P
	///*******CREATED DATE          : 2/6/2018
	///*******MODIFIED DEVELOPER    : DATE - NAME - WHAT IS MODIFIED; *************************
	this.htmlTemplateServiceUnSignEasyForm = function (postData) {

		postData.ApplicationType = EMRPracticeModel.ApplicationType;
		postData.PortalUserType = EMRPracticeModel.PortalUserType;
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.clientIP = EMRPracticeModel.clientIP;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		postData.ehrIsImpersonatedUserAuditID = EMRPracticeModel.ehrIsImpersonatedUserAuditID;
		postData.ehrImpersonateLoggedUserID = EMRPracticeModel.ehrImpersonateLoggedUserID;
		postData.PracticeName = EMRPracticeModel.PracticeName;
		postData.EHRJSONRequestLogEMRDateTime = adminGetCurrentDateAndTime();
		postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
		postData.FirstName = EMRPracticeModel.FirstName;
		postData.UserType = EMRPracticeModel.UserType;
		postData.LastName = EMRPracticeModel.LastName;
		postData.MiddleInitial = EMRPracticeModel.MiddleInitial;
		postData.LoggedFacilityName = EMRPracticeModel.LoggedFacilityName;
		postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;
		postData.EHREasyFormsCommonJSFileName = EMRPracticeModel.EHREasyFormsCommonJSFileName;
		postData.emrurlsmodel = {
			EMRWebWCFPrimaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL,
			EMRWebWCFSecondaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL,
			EMRCentralizerSocketPrimaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketPrimaryURL,
			EMRCentralizerSocketSecondaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL,
		}
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.SHOWPROGRESS;
		postData.ehrAdminCurrentCallingMessage = "Easy Form Unsign is in Progress ...";
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_EasyFormSave_API() + "UnsignEasyFormNotes", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  UNSIGN EASY FORM VALIDATION - BLOCK END #########################

	this.htmlTemplatesRunEasyFormPNFSService = function (postData) {

		postData.ApplicationType = EMRPracticeModel.ApplicationType;
		postData.clientIP = EMRPracticeModel.clientIP;
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.PortalUserType = EMRPracticeModel.PortalUserType;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		postData.PracticeName = EMRPracticeModel.PracticeName;
		postData.EHRJSONRequestLogEMRDateTime = adminGetCurrentDateAndTime();
		postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
		postData.FirstName = EMRPracticeModel.FirstName;
		postData.UserType = EMRPracticeModel.UserType;
		postData.LastName = EMRPracticeModel.LastName;
		postData.MiddleInitial = EMRPracticeModel.MiddleInitial;
		postData.LoggedFacilityName = EMRPracticeModel.LoggedFacilityName;
		postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;
		postData.EHREasyFormsCommonJSFileName = EMRPracticeModel.EHREasyFormsCommonJSFileName;
		postData.emrurlsmodel = {
			EMRWebWCFPrimaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL,
			EMRWebWCFSecondaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL,
			EMRCentralizerSocketPrimaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketPrimaryURL,
			EMRCentralizerSocketSecondaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL,
		}
		postData.practicemodel = EMRPracticeModel;

		postData.ehrAdminCurrentCallingActionType = undefined;

		// CHEKING THE IS EASYFORM FIELDED SAVING EXE RUN FORM SAVED NOTES THEN SHOWING CIRCLE IN CENTER OF THE APPLICATION
		if (hasValue(postData) && hasValue(postData.isFromEasyFormSavedNotesTab) && postData.isFromEasyFormSavedNotesTab == true) {
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.SHOWPROGRESS;
			postData.ehrAdminCurrentCallingMessage = "Easy Form PNFS is in Progress ...";
		}

		var timeOut = 180 * 1000;

		//var savingtemplateURL = CommonService.EMRClinicalManagement_HTMLTemplatesEasyFormSave() + "ExecuteEasyFormFieldedSavingExe";
		var savingtemplateURL = CommonService.EHR_EasyFormSave_API() + "RunEasyFormPNFSService";


		if (window.location.href.indexOf("localhost") > 0) {

		} else {
			//if the current url is primary then sending  the log requests through secondary
			if (savingtemplateURL.indexOf(EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL) >= 0)
				savingtemplateURL = savingtemplateURL.replace(EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL, EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL);
			else if (savingtemplateURL.indexOf(EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL) >= 0)
				savingtemplateURL = savingtemplateURL.replace(EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL, EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL);
		}

		return CommonService.PostData('POST', savingtemplateURL, postData, 5 * 60 * 1000).then(
			function (result) {
				return result;
			});
	};

	//################### GET EASY FORM MAPPED STATIC CALCULATED HCI FIELDS INFO BLOCK START #########################
	///*******PURPOSE           : THIS METHOD IS TO  GET EASY FORM MAPPED STATIC CALCULATED HCI FIELDS INFO
	///*******CREATED BY        : AJAY.NANDURI
	///*******CREATED DATE      : 26/11/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.htmlTemplatesGetEasyFormMappedStaticCalculatedHCIFieldsInfo = function (postData) {
		// ASSIGNING THE CURRENT API CALLING ACTION TYPE 
		// IF IT IS SAVING THEN IT SHOWS TO USER SAVING IN PROGRESS ACTION MESSAGE
		// WHICHC HELPS TO IDENTIFY WHAT ACTION TYPE OF API REQUEST
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA
		// ASSIGNING THE PRACTICE MODEL TO THE INPUT DATA
		// THIS PARACTICE MODEL CONSISTS ALL THE INFO OF CURRENT USER LOGIN LINKED PRACTICE INFO
		// THIS PRACTICE MODEL CONSISTS LOGGED USER INFO
		postData.practicemodel = EMRPracticeModel;
		// CALLING THE CENTRALIZED SERVICE METHOD WHICH POST THE API REQUEST TO SAVE CUSTOMIZED FIELDS INFO
		// BY USING THE COMMON SERVICE IT GENERATES THE POST REQUEST URL WITH REQUESTED INPUT DATA
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_AggregateCalculatedHCI_API() + "GetEasyFormMappedStaticCalculatedHCIFieldsInfo", postData).then(
			function (result) {
				return result;
			});
	};
	//################### GET EASY FORM MAPPED STATIC CALCULATED HCI FIELDS INFO BLOCK END #########################

	//################### TO INSERT THE USER DATA WHO IS EDITING THE LABEL NAME OF EASY FORM BLOCK START #########################
	//*******PURPOSE           : THIS METHOD IS TO INSERT THE USER DATA WHO IS EDITING THE LABEL NAME OF EASY FORM
	//*******CREATED BY        : Deepika Rapolu
	//*******CREATED DATE      : Jan 24, 2020
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.EasyFormLabelCaptionConcurrentUserAcessInsert = function (postData) {
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.clientIP = EMRPracticeModel.clientIP;
		//ASSIGNING THE PRACTICE MODEL TO THE INPUT DATA
		//THIS PARACTICE MODEL CONSISTS ALL THE INFO OF CURRENT USER LOGIN LINKED PRACTICE INFO
		postData.practicemodel = EMRPracticeModel;
		//CALLING THE CENTRALIZED SERVICE METHOD WHICH POST THE API REQUEST TO SAVE CUSTOMIZED FIELDS INFO
		//BY USING THE COMMON SERVICE IT GENERATES THE POST REQUEST URL WITH REQUESTED INPUT DATA
		//TO INSER THE EASY FORM LABEL EDITING USER IFO
		return CommonService.PostData('POST', CommonService.EHR_EFConcurrentAccesLocking_API() + "EasyFormLabelCaptionConcurrentUserAcessInsert", postData).then(
			function (result) {
				return result;
			});
	};
	//################### TO INSERT THE USER DATA WHO IS EDITING THE LABEL NAME OF EASY FORM BLOCK END #########################

	//################### TO DELETE THE USER DATA WHO EDITED THE LABEL NAME OF EASY FORM BLOCK START #########################
	//*******PURPOSE           : THIS METHOD IS TO DELETE THE USER DATA WHO EDITED THE LABEL NAME OF EASY FORM
	//*******CREATED BY        : Deepika Rapolu
	//*******CREATED DATE      : Jan 24, 2020
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.CreateNewNotesLabelCaptionEditlockedEasyFormDelete = function (postData) {
		//ASSIGNING THE PRACTICE MODEL TO THE INPUT DATA
		//THIS PARACTICE MODEL CONSISTS ALL THE INFO OF CURRENT USER LOGIN LINKED PRACTICE INFO
		postData.practicemodel = EMRPracticeModel;
		//CALLING THE CENTRALIZED SERVICE METHOD WHICH POST THE API REQUEST TO SAVE CUSTOMIZED FIELDS INFO
		//BY USING THE COMMON SERVICE IT GENERATES THE POST REQUEST URL WITH REQUESTED INPUT DATA
		//TO DELETE THE EASY FORM LABEL EDITITNG USER INFO
		return CommonService.PostData('POST', CommonService.EHR_EFConcurrentAccesLocking_API() + "CreateNewNotesLabelCaptionEditlockedEasyFormDelete", postData).then(
			function (result) {
				return result;
			});
	};
	//################### TO DELETE THE USER DATA WHO EDITED THE LABEL NAME OF EASY FORM BLOCK END #########################


	//################### GET TEMPLATE DETAILS BASED ON CHART ID BLOCK START #########################
	//*******PURPOSE: This method is used for getting the html tempalte details based on the chart id
	//*******CREATED BY: MAHESH P
	//*******CREATED DATE: 04/22/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTempaltesGetTemplateDetailsBasedOnChartID = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonService.PostData('POST', CommonService.EHR_EF_Miscellaneous_API() + "GetHtmlTemplateDetailsBasedOnChartID", postData).then(
			function (result) {
				return result;
			});
	};
	//################### GET TEMPLATE DETAILS BASED ON CHART ID BLOCK END #########################

    /* This method is used to update Display Sequence of EasyForm Linked Abbreviations 
     * Created By:sudheer.kommuri
     * Created On:19/08/2020
     * param {object} InputData
     * returns {object} result
     */
	this.GetCQMEasyFormsLinkedList = function (InputData) {
		InputData.practicemodel = EMRPracticeModel;
		InputData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_CreateNewNotes_API() + "GetCQMEasyFormsLinkedList", InputData).then(
			function (result) {
				return result;

			});
	};

    /* This method is used to update Display Sequence of EasyForm Linked Abbreviations 
     * Created By:sudheer.kommuri
     * Created On:19/08/2020
     * param {object} InputData
     * returns {object} result
     */
	this.UpdateCQMduesLinkedSignedFormsStatus = function (InputData) {
		InputData.practicemodel = EMRPracticeModel;
		InputData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_CreateNewNotes_API() + "UpdateCQMduesLinkedSignedFormsStatus", InputData).then(
			function (result) {
				return result;

			});
	};

	//################### METHOD TO GET EXAM OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST  BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET EXAM OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST
	//*******CREATED BY: AMARNATH
	//*******CREATED DATE: 04/08/2019
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.HPIServiceGetExamObjectsDefaultOptionsLinkedPhysiciansList = function (postData) {
		postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHRExam() + "GetExamObjectsDefaultOptionsLinkedPhysiciansListWeb", postData).then(
			function (result) {
				return result;
			});
	};
    //################### METHOD TO GET EXAM OBJECTS DEFAULT OPTIONS LINKED PHYSICIANS LIST  BLOCK END #########################

	//################### GET GET EXAM TEMPLATE OBJECT LINKED DEFAULt ANSWER DETAILS BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET EXAM TEMPLATE OBJECT LINKED DEFAULt ANSWER DETAILS
	//*******CREATED BY: PHANI KUMAR M
	//*******CREATED DATE: 19 TH DEC 2017
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.easyFormHPIGetExamTemplateLinkedObjectsDefaultAnswers = function (postData) {
		postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHRExam() + "GetExamTemplateLinkedObjectsDefaultAnswers", postData).then(
			function (result) {
				return result;
			});
	};
    //################### GET GET EXAM TEMPLATE OBJECT LINKED DEFAULt ANSWER DETAILS BLOCK END #########################

	//################### GET PREVIOUSLY CUSTOMIZED TITLES LIST INFO BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET TITLES LIST INFO
	//*******CREATED BY: UDAY KIRAN V
	//*******CREATED DATE: 11/16/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.easyFormHPIGetPreviouslyCustomizedHPITitlesListService = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_HPITreeview_API() + "GetPreviouslyCustomizedHPITitlesListInfo", postData).then(
			function (result) {
				return result;
			});
	};
    //################### GET PREVIOUSLY CUSTOMIZED TITLES LIST INFO BLOCK END #########################

	// Billing Polices / Insurances relacted Services - Block Start

	//##############################################             GET CMS1500 INSURANCE TYPE DETAILS         ########################################

	//#########  GET CMS1500 INSURANCE TYPE DETAILS  ##############
	//*******PURPOSE: THIS METHOD IS USED TO GET CMS1500 INSURANCE TYPE DETAILS
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.getCMS1500InsurancetypeDetails = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		//API changed to "EHR_Billing_API" from "EMR_PracticeManagement"
		//return CommonService.PostData('POST', CommonService.EHR_Billing_HealthPlan_API() + "GetCMS1500InsuranceTypeDetails", postData).then(function (result) { return result; });
        //API changed to "EHR_Inurance_API" from "EHR_Billing_API" by Pavan.Burri on Dec 16th 2020.
        return CommonService.PostData('POST', CommonService.EHR_Insurance_API() + "GetCMS1500InsuranceTypeDetails", postData).then(function (result) { return result; });

	};

	//##############################################             GET CMS1500 INSURANCE TYPE DETAILS - END         ########################################

	//#########   GET 837 INSURANCE DETAILS  ##############
	//*******PURPOSE: THIS METHOD IS GET 837 INSURANCE DETAILS
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.Get837InsTypeList = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		//API changed to "EHR_Billing_API" from "EMR_PracticeManagement"
		//return CommonService.PostData('POST', CommonService.EHR_Billing_HealthPlan_API() + "Get837InsTypeList", postData).then(function (result) { return result; });
		//API changed to "EHR_Insurance_API" from "EHR_Billing_API"
        return CommonService.PostData('POST', CommonService.EHR_Insurance_API() + "Get837InsTypeList", postData).then(function (result) { return result; });

	};

	//##############################################              GET INSURANCE CATEGORIES - END         ########################################

	//#########   GET CMS 1500 INSURANCE QUALIFIERS DETAILS  ##############
	//*******PURPOSE: THIS METHOD IS GET CMS 1500 INSURANCE QUALIFIERS DETAILS
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.GetCMS1500QualifierDetails = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		//API is changed to "EHR_Billing_API" solution by Rajasekhar as per Board ID - 294/295
		return CommonService.PostData('POST', CommonService.EHR_Billing_Box33B_Customization() + "GetCMS1500QualifierDetails", postData).then(function (result) { return result; });
        
	};

	//##############################################              GET INSURANCE CATEGORIES - END         ########################################

	//########################### GET STATES UDS HEALTH PLAN TYPES  BLOCK START #########################

	/// *******PURPOSE:THIS FUNCTION IS USED TO GET UDS HEALTH PLAN TYPES LIST
	///*******CREATED BY:PHANI KUMAR M
	///*******CREATED DATE: 09/22/2015
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
	this.GetUDSHelathPlanTypesList = function () {
		var postData = { practicemodel: EMRPracticeModel }
		//API changed to "EHR_Billing_API" from "EMR_PracticeManagement"
		//return CommonService.PostData('POST', CommonService.EHR_Billing_HealthPlan_API() + "GetUDSHelathPlanTypesList", postData).then(
        //API changed to "EHR_Inurance_API" from "EHR_Billing_API" by Pavan.Burri on Dec 16th 2020.
        return CommonService.PostData('POST', CommonService.EHR_Insurance_API() + "GetUDSHelathPlanTypesList", postData).then(
			function (result) {
				return result;
			});
	};
	////############################## GET UDS HEALTH PLAN TYPES LIST BLOCK END #########################

	//#########  GET X RAYS DETAILS  ##############
	//*******PURPOSE: THIS METHOD IS USED TO GET X RAYS DETAILS
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.getXraysDetails = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		return CommonService.PostData('POST', CommonService.EMRPracticeManagement_Billing() + "GetXraysDetails", postData).then(function (result) { return result; });

	};

	//##############################################             GET LABS DETAILS - END         ########################################

	//##############################################             GET INSURANCE CATEGORIES         ########################################

	//#########   GET INSURANCE CATEGORIES  ##############
	//*******PURPOSE: THIS METHOD IS USED TO  GET INSURANCE CATEGORIES
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.getinsuranceCategoryDetails = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		//API changed to "EHR_Billing_API" from "EMR_PracticeManagement"
		//return CommonService.PostData('POST', CommonService.EHR_Billing_HealthPlan_API() + "GetinsuranceCategoryDetails", postData).then(function (result) { return result; });
        //API changed to "EHR_Inurance_API" from "EHR_Billing_API" by Pavan.Burri on Dec 16th 2020.
        return CommonService.PostData('POST', CommonService.EHR_Insurance_API() + "GetinsuranceCategoryDetails", postData).then(function (result) { return result; });

	};

	//##############################################              GET INSURANCE CATEGORIES - END         ########################################

	//##############################################             GET LABS DETAILS         ########################################

	//#########  GET LABS DETAILS  ##############
	//*******PURPOSE: THIS METHOD IS USED TO GET LABS DETAILS
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 07/02/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.getHL7ORMLaboratoryTypeConfiguredByEMR = function (postData) {

		postData.practicemodel = EMRPracticeModel;
		//API changed to "EHR_Billing_API" from "EMR_PracticeManagement" by Rajasekhar M  on 09/12/2020
		//return CommonService.PostData('POST', CommonService.EHR_Billing_HealthPlan_API() + "GetHL7ORMLaboratoryTypeConfiguredByEMR", postData).then(function (result) { return result; });
        //API changed to "EHR_Inurance_API" from "EHR_Billing_API" by Pavan.Burri on Dec 16th 2020.
        return CommonService.PostData('POST', CommonService.EHR_Insurance_API() + "GetHL7ORMLaboratoryTypeConfiguredByEMR", postData).then(function (result) { return result; });

	};

	//##############################################             GET LABS DETAILS - END         ########################################

	// Billing Polices / Insurances relacted Services - Block End

	/**
     * This function is used to Get Form Linked HCI info
     * @param {Form IDs as a list} InputData
     */
	this.GetFormlinkedHCIInfoForMultipleForms = function (InputData) {
		InputData.practicemodel = EMRPracticeModel;
		//InputData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_AddandLinkHCItoEFField_API() + "GetFormsLinkedHCIInfo", InputData).then(
			function (result) {
				return result;

			});
	};
	//called in commonfactory,PracticeAdminEMRCommonFactory
	this.sendEFScriptFunctionClickLogsMailtoAngularTechSupport = function (body) {
		if (!body) return;
	//   $.ajax({
	// 		type: "POST",
	// 		url: `${CommonPostService.EHR_SendMail()}SendAngularjsErrortoTechSupport`,
	// 		//url: `http://192.168.0.103/EHR_SendMailAPI/EHRMailController/SendAngularjsErrortoTechSupport`,
	// 		data: JSON.stringify({
	// 			 "MailSubject": "IFrame Easy Form Script Function Clicks Logs In Local Storage",
	// 			 "MailBody": body,
	// 			 "MailAttachmentinBase64String": 'R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
	// 		}),
	// 		success: function (success) {
	// 			 removeStoredLogsFromLS(body);
	// 		},
	// 		error: function (errorThrown) {
	// 			 // console.log(errorThrown);
	// 		},
	// 		contentType: "application/json",
	// 		dataType: 'json'
	//   });
		let requestBody = {
			"MailSubject": "IFrame Easy Form Script Function Clicks Logs In Local Storage",
			"MailBody": body,
			"MailAttachmentinBase64String": 'R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
			"toMails":[]
		}
		GoogleCloudFunctionHandlerService.post("EHR_SendAngularjsErrortoTechSupport_GCloudFunc", requestBody).then(function (response) {
			if (isError(response)) {
				return;
			}
		});
 }
 function removeStoredLogsFromLS(body) {
	  let listItems = JSON.parse($base64.decode(body))
	  _.forEach(listItems, function (item) {
			localStorage.removeItem(item.FinallogKeyToStore);
	  });
 }


	this.ValidateUndoCompleteEasyForm = function (postData) {

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EasyFormSave_API() + "ValidateUndoCompleteEasyForm", postData);
	};
	this.UndoCompleteEasyForm = function (postData) {
		postData.ApplicationType = EMRPracticeModel.ApplicationType;
		postData.PortalUserType = EMRPracticeModel.PortalUserType;
		postData.clientSystemLocalIP = EMRPracticeModel.clientSystemLocalIP;
		postData.clientIP = EMRPracticeModel.clientIP;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		postData.ehrIsImpersonatedUserAuditID = EMRPracticeModel.ehrIsImpersonatedUserAuditID;
		postData.ehrImpersonateLoggedUserID = EMRPracticeModel.ehrImpersonateLoggedUserID;
		postData.PracticeName = EMRPracticeModel.PracticeName;
		postData.EHRJSONRequestLogEMRDateTime = adminGetCurrentDateAndTime();
		postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
		postData.FirstName = EMRPracticeModel.FirstName;
		postData.UserType = EMRPracticeModel.UserType;
		postData.LastName = EMRPracticeModel.LastName;
		postData.MiddleInitial = EMRPracticeModel.MiddleInitial;
		postData.LoggedFacilityName = EMRPracticeModel.LoggedFacilityName;
		postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;
		postData.EHREasyFormsCommonJSFileName = EMRPracticeModel.EHREasyFormsCommonJSFileName;
		postData.emrurlsmodel = {
			EMRWebWCFPrimaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL,
			EMRWebWCFSecondaryExternalURL: EMRPracticeModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL,
			EMRCentralizerSocketPrimaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketPrimaryURL,
			EMRCentralizerSocketSecondaryURL: EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL,
		}
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.SHOWPROGRESS;
		postData.ehrAdminCurrentCallingMessage = "Easy Form Undo Complete is in Progress ...";
		const postDataTimout = 2 * 60 * 1000;//2 min
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EasyFormSave_API() + "UndoCompleteEasyForm", postData, postDataTimout);
	};
	this.getEfSavedNotesViewPermissionsInfoBasedOnTemplateID = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_EF_SavedNotesViewPermissions_API() + "GetEfSavedNotesViewPermissionsInfoBasedOnTemplateID", postData);
	};
	this.GetViewPermissionsCustomisedTemplatesInfoList = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_EF_SavedNotesViewPermissions_API() + "GetViewPermissionsCustomisedTemplatesInfoList", postData);
	};
	this.GetStaticHCIItemsLinkedtoTemplate = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHR_EasyFormSave_API() + "GetStaticHCIItemsLinkedtoTemplate", postData);
    };

	this.GetEasyFormFormsSettingsLinkEasyFormtoProgramsInfo = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_CreateNewNotes_API() + "GetEasyFormFormsSettingsLinkEasyFormtoProgramsInfoModelList", postData);
    };

	this.getEasyFormSavedNotesViewPermissionsInfoBasedOnFormID = async function (easyFormID, PatientID) {
		let _EasyFormCommonService = this;

		const isTemplateFound = await _EasyFormCommonService.getEasyFormSavedNotesViewPermissionsTemplatesInfoList(easyFormID);

		if (!isTemplateFound) return $q.resolve(3);

		let emrcommonfactory = $injector.get('EMRCommonFactory');

		let viewsavednotespermissionID = emrcommonfactory.getEFSavedNotesViewPermissionsInfoBasedOnFormID(easyFormID);

		if (viewsavednotespermissionID && viewsavednotespermissionID > 0) {
			return $q.resolve(viewsavednotespermissionID);
		}

		return _EasyFormCommonService.getEfSavedNotesViewPermissionsInfoBasedOnTemplateID({
			EfTemplateID: easyFormID,
			PatientID: PatientID
		}).then(function (serviceResponse) {
			if (!serviceResponse || isError(serviceResponse)) return 3;

			const permissionID = serviceResponse.EasyFormViewPermissionID || 3;

			emrcommonfactory.setEasyFormSavedNotesViewPermissionsInfoBasedOnFormID(easyFormID, permissionID);

			return permissionID;
		});
	}

	this.getEasyFormSavedNotesViewPermissionsTemplatesInfoList = function (easyFormID) {
		let _EasyFormCommonService = this;

		let emrcommonfactory = $injector.get('EMRCommonFactory');

		let viewsavednotespermissionsList = emrcommonfactory.getEFSavedNotesViewPermissionsTemplatesInfoList();

		if (_.size(viewsavednotespermissionsList)) {
			return $q.resolve(_.some(viewsavednotespermissionsList, ['TemplateID', easyFormID]));
		}

		return _EasyFormCommonService.GetViewPermissionsCustomisedTemplatesInfoList({}).then(function (serviceResponse) {
			if (!serviceResponse || isError(serviceResponse)) return false;

			const { ViewPermissionsCustomisedTemplatesInfoList } = serviceResponse;

			emrcommonfactory.setEFSavedNotesViewPermissionsTemplatesInfoList(ViewPermissionsCustomisedTemplatesInfoList || []);

			return _.some(ViewPermissionsCustomisedTemplatesInfoList, ['TemplateID', easyFormID]);
		});
	}


	this.getEasyFormDetailsBasedOnFormID = function (easyFormID) {
		let _EasyFormCommonService = this;
		let deferred = $q.defer();
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		const EasyFormsLKPList = emrcommonfactory.getEasyFormsLKPsInfoIntoGlobalObject();
		if (_.size(EasyFormsLKPList))
			deferred.resolve(_.find(EasyFormsLKPList, ['EasyFormID', easyFormID]));
		else {
			_EasyFormCommonService.getAndSetEasyFormsLKPsInfoIntoGlobalObject().then(function () {
				const EasyFormsLKPList = emrcommonfactory.getEasyFormsLKPsInfoIntoGlobalObject();
				if (_.size(EasyFormsLKPList))
					deferred.resolve(_.find(EasyFormsLKPList, ['EasyFormID', easyFormID]));
				else
					deferred.resolve({ EasyFormID: easyFormID });
			});
		}

		return deferred.promise;
	}

	this.checkAnyPriorEasyFormRulesExistForTheFormOrNot = function (easyFormID) {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		const EasyFormsLKPList = emrcommonfactory.getEasyFormsLKPsInfoIntoGlobalObject();
		const PriorEasyFormsRulesCustomizationList = emrcommonfactory.getEasyFormsPriorEasyFormsRulesCustomizationList();
		/*here we are checking if EasyFormsLKPList is exits or not,if exits then we execute if block,else we execute block for to get Easy Form LKP List */
		if (_.size(EasyFormsLKPList)) {
			if (_.size(PriorEasyFormsRulesCustomizationList))
				return PriorEasyFormsRulesCustomizationList.includes(easyFormID);
			else
				return false;
		} else {
			/*here we are going to service call and get the easyform lkp list and prior easyform rules List*/
			return _EasyFormCommonService.getAndSetEasyFormsLKPsInfoIntoGlobalObject().then(function () {
				const PriorEasyFormsRulesCustomizationList = emrcommonfactory.getEasyFormsPriorEasyFormsRulesCustomizationList();
				/*after getting the Response we are checking easyform id exits or not ,if it exist then we resturn true else false*/
				if (_.size(PriorEasyFormsRulesCustomizationList))
					return PriorEasyFormsRulesCustomizationList.includes(easyFormID);
				else
					return false;
			});
		}
	}

	this.getAndSetEasyFormList = function () {

		let deferred = $q.defer();
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		const EasyFormsLKPList = emrcommonfactory.getEasyFormsLKPsInfoIntoGlobalObject();
		if (_.size(EasyFormsLKPList))
			deferred.resolve(EasyFormsLKPList);
		else {
			_EasyFormCommonService.getAndSetEasyFormsLKPsInfoIntoGlobalObject().then(function () {
				const EasyFormsLKPList = emrcommonfactory.getEasyFormsLKPsInfoIntoGlobalObject();
				if (_.size(EasyFormsLKPList))
					deferred.resolve(EasyFormsLKPList);
				else
					deferred.resolve([]);
			});
		}

		return deferred.promise;
	}

	this.getAndSetEasyFormsLKPsInfoIntoGlobalObject = function () {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		return _EasyFormCommonService.htmlTemplateGetEasyFormsLKPList({}).then(function (serviceResponse) {
			/*If any error in service response then we are return from here*/
			if (isError(serviceResponse)) return;
			emrcommonfactory.setEasyFormsLKPsInfoIntoGlobalObject(serviceResponse.EasyFormsLKPDetailsList || []);
			emrcommonfactory.setEasyFormsPriorEasyFormsRulesCustomizationList(serviceResponse.PriorEasyFormsCustomizationList || []);
		});
	}

	this.getEasyFormLinkedNotesBlockingRules = function (EasyFormID) {

		// creating the promise to return the template linked notes blocking rules
		// this promise will helps us to return the data untill service response is getting
		let deferred = $q.defer();
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		const EHRTemplateWiseNotesBlockingRules = emrcommonfactory.getEasyFormLinkedNotesBlockingRulesBasedOnFormId(EasyFormID);
		// checking the centralized object having the value or not and also current template blokcing rules info is exists in the the object r not
		// if not exists then make a service call to get template linked notes blocking rules  info and save in this centralized object
		// if data present then return the list
		if (EHRTemplateWiseNotesBlockingRules) {
			deferred.resolve(EHRTemplateWiseNotesBlockingRules);
		}
		else {
			// creating the postdata which holds the required i/p data to get notes blocking rules info
			var postData = {
				FillableHTMLDocumentTemplateID: EasyFormID, // template id
			};
			// make a service call to get the template linked notes blocking rules
			// After getting the service response set the data in local bcz next time we are not going to make a service call 
			// just read it form local variable
			_EasyFormCommonService.htmlTemplateServiceGetEasyFormLinkedNotesBlockingRules(postData).then(function (serviceResponse) {
				// After getting the serviceresponse checking the is any error in result or not by calling centralized function
				if (isError(serviceResponse)) return deferred.resolve([]);
				// checking the is easyform having the any notes blocking rules or not
				// if exists then setting the value in local variable
				// rsolve the promise with the rules list
				if (hasValue(serviceResponse) && hasValue(serviceResponse.EasyFormsBlockingRulesInfoList) && serviceResponse.EasyFormsBlockingRulesInfoList.length > 0) {
					emrcommonfactory.setEasyFormLinkedNotesBlockingRulesBasedOnFormId(EasyFormID, serviceResponse.EasyFormsBlockingRulesInfoList)
					deferred.resolve(serviceResponse.EasyFormsBlockingRulesInfoList);
				}
				// else cache and resolve the promise with empty list
				else {
					emrcommonfactory.setEasyFormLinkedNotesBlockingRulesBasedOnFormId(EasyFormID, []);
					deferred.resolve([]);
				}
			});
		}
		// finaly reurn the promise response to the calling function
		return deferred.promise;
	}

	this.getOrCheckEasyFormIDsHavingNotesBlckingRulesWithInPrac = function (easyFormID) {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		const EasyFormsTemplateIdsForNotesBlockingList = emrcommonfactory.getEasyFormsTemplateIdsBlockingList();
		if (emrcommonfactory.EMRIsNotesBlockingEasyFormIdsListExists())
			return EasyFormsTemplateIdsForNotesBlockingList && EasyFormsTemplateIdsForNotesBlockingList.includes(easyFormID);
		else {
			//this method is useful in getting the all the templates blocking rule info
			return _EasyFormCommonService.getTemplateIdsHavingNotesBlockingRules({}).then(function (serviceResponse) {

				if (isError(serviceResponse)) return false;

				if (hasValue(serviceResponse) && serviceResponse.length > 0) {
					// get distinct template ids using lodash func
					var TemplateIds = _.map(_.uniqBy(serviceResponse, 'FillableHTMLDocumentTemplateID'), 'FillableHTMLDocumentTemplateID');

					// setting global template list
					emrcommonfactory.EMRSetEasyFormsTemplateIdsBlockingList(TemplateIds);

				} else {
					// setting global template list
					emrcommonfactory.EMRSetEasyFormsTemplateIdsBlockingList([]);
				}
				const EasyFormsTemplateIdsForNotesBlockingList = emrcommonfactory.getEasyFormsTemplateIdsBlockingList();
				return EasyFormsTemplateIdsForNotesBlockingList && EasyFormsTemplateIdsForNotesBlockingList.includes(easyFormID);
			});
		}
	}

	this.SetNotesHideAfterPatientDischargefromProgramserviceFlag = function () {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');
		/*here we are calling this service for to getting notes hide for logged user when patient discharge from program flag value*/
		_EasyFormCommonService.GettingNoteshideaferPatientDischargefromProgramSettingInfo({}).then(function (ServiceResponse) {
			/*If any error in service response then we are return from here*/
			if (isError(ServiceResponse)) return;
			/*if the value in the service response and IshideNotesAfterPatientDischargefromProgram falg value is true then we are setting  true to the  IsNoteshideWhenPatientDischargedFromanyProgram flag
			 *based on this flag only we can get the discharged patient notes of logged user */
			if (_.get(ServiceResponse, 'DocumentsArchivingPolicySettingDetailsModel.IshideNotesAfterPatientDischargefromProgram')) {
				emrcommonfactory.setNotesHideAfterPatientDischargefromProgramServiceFlagValue(ServiceResponse.DocumentsArchivingPolicySettingDetailsModel.IshideNotesAfterPatientDischargefromProgram);
			}
		});
	}

	this.checkForEasyformsButtonsCustomizationExistence = function (requiredInputParametersObj) {
		let _EasyFormCommonService = this;
		if (!_.isEmpty(requiredInputParametersObj) && !_.isEmpty(requiredInputParametersObj.customizedButtonsListObjInfo)) {
			return $q.when(requiredInputParametersObj.customizedButtonsListObjInfo);
		}
		if (hasValue(requiredInputParametersObj) && requiredInputParametersObj.noNeedOfActionButtonsCalling)
			return $q.when({ isFromSavedNotesWithoutTempID: true });

		if (hasValue(requiredInputParametersObj) && requiredInputParametersObj.TemplateID > 0) {
			var postData = {
				EasyFormButtonsCustomizationByLoggedUserModel: {
					FillableHtmlDocumentTemplateID: requiredInputParametersObj.TemplateID,  // THIS MODEL OBJECT IS TO HODL THE TEMPLATE ID
					IsPayorValidationExists: Boolean(requiredInputParametersObj.isPayerBtnsvalidationrequired),
					PatientID: requiredInputParametersObj.PatientID || null,
					FillableHtmlDocumentPatientDataId: requiredInputParametersObj.FillableHtmlDocumentPatientDataId,
					AppointmentID: requiredInputParametersObj.AppointmentID
				},
				/**
				 * 
				  Issue:
				   The form did not customize the Sign Off button based on any payor.
				  They only customized the Complete and Save as Draft buttons for payor-based.
				  But the same forms contain the Sign Off button for all users.
				  Scenario:
				  The patient had the same payor that matches the button customization which has only Complete and Save as Draft.
				  When the form was first Finalized in the portal and then came back to the Patient Chart → Saved Notes, it is showing the Sign Off button.
				  Issue:
				   Since the patient’s payor matches the customization (which has only Complete and Save as Draft), the Sign Off button should not be shown in Saved Notes.
				 */
				IsFromSavedNotesNavigation: Boolean(requiredInputParametersObj.isFromSavedNotesDirective),
			};
			return _EasyFormCommonService.htmlTemplatesGetEasyFormCustomizedActionBtnsBasedOnTemplateID(postData).then(function (serviceResponse) {
				// IF IS ANY ERROR IN SERVICE RESPONSE THEN REJECT THE PROMISE WITH THE FALSE STATUS
				if (isError(serviceResponse)) return $q.when({});

				if (_.size(serviceResponse.EasyFormCustomizedButtonsList) > 0) {
					return $q.when(_.assign({}, _.keyBy(serviceResponse.EasyFormCustomizedButtonsList, "EasyFormButtonsCustomizationActionButtonID"), {
						PayorId: serviceResponse.PayorId,//inorder to saving in form saving
						PayorLinkedUserType: serviceResponse.PayorLinkedUserType
					}));
				}
				if (_.size(serviceResponse.PatientLinkedPayorsList) > 0) {
					return _EasyFormCommonService.openPopupToSelectPayerToGetButtonsCustomization(requiredInputParametersObj.TemplateID, serviceResponse).then(function (result) {
						return result;
					});
				} else
					return $q.when({});
			});
		}
		else if (hasValue(requiredInputParametersObj) && requiredInputParametersObj.isFromSavedNotesDirective)
			return $q.when({ isFromSavedNotesWithoutTempID: true });
		else {
			return $q.when({})
		}
	}

	this.openPopupToSelectPayerToGetButtonsCustomization = function(templateID, serviceResponse) {
		let _EasyFormCommonService = this;
		let ModalPopupService = $injector.get('ModalPopupService');
		let dataToPopup = {
			PatientLinkedPayorsList: serviceResponse.PatientLinkedPayorsList || [],
		}
		return ModalPopupService.OpenPopup(GetEMRPageURLByIndex(4601), dataToPopup, 'modal-400px').then(function (result) {
			var postData = {
				EasyFormButtonsCustomizationByLoggedUserModel: {
					FillableHtmlDocumentTemplateID: templateID,  // THIS MODEL OBJECT IS TO HODL THE TEMPLATE ID
					IsPayorValidationExists: false,
				}
			}
			if (result && result != "cancel") {
				postData.EasyFormButtonsCustomizationByLoggedUserModel.PayorID = (result && result.PayorID) || "";
				postData.EasyFormButtonsCustomizationByLoggedUserModel.PayorLinkedUserType = (result && result.PayorLinkedUserType) || "";
			}
			return _EasyFormCommonService.htmlTemplatesGetEasyFormCustomizedActionBtnsBasedOnTemplateID(postData).then(function (serviceResponse) {
				// IF IS ANY ERROR IN SERVICE RESPONSE THEN REJECT THE PROMISE WITH THE FALSE STATUS
				if (isError(serviceResponse)) return $q.when({});

				if (_.size(serviceResponse.EasyFormCustomizedButtonsList) > 0) {
					return $q.when(_.assign({}, _.keyBy(serviceResponse.EasyFormCustomizedButtonsList, "EasyFormButtonsCustomizationActionButtonID"), {
						PayorId: serviceResponse.PayorId || (result && result.PayorID),//inorder to saving in form saving
						PayorLinkedUserType: serviceResponse.PayorLinkedUserType || (result && result.PayorLinkedUserType)
					}));
				} else
					return $q.when({});
			});
		})
	}

	this.checkForEasyformEditCustomizationPermissionList = async function (keyToCheck, postData) {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');

		// CHECKING WHETHER DETAILS ALREADY EXISTS OR NOT
		if (emrcommonfactory.getEHRSettingsInformationForCurrentlyLoggedUsersModuleKey(keyToCheck)) {
			return emrcommonfactory.getEHRSettingsInformationForCurrentlyLoggedUsersBasedOnModuleKey(keyToCheck);
		}

		// ELSE WE NEED TO DO SERVICE CALL FOR GETTING EASY FORM EDIT CUSTOMIZATION PERMISSION LIST
		const serviceResponse = await _EasyFormCommonService.htmlTemplatesGetEasyformEditCustomizationPermissionList(postData);

		if (!serviceResponse || isError(serviceResponse)) return [];

		if (hasValue(serviceResponse.EasyformEditCustomizationPermissionList) &&
			serviceResponse.EasyformEditCustomizationPermissionList.length > 0) {
			// ASSIGNING DATA TO ARRAY
			emrcommonfactory.setEHRSettingsInformationForCurrentlyLoggedUsersBasedOnModuleKey(keyToCheck, serviceResponse.EasyformEditCustomizationPermissionList);
			return serviceResponse.EasyformEditCustomizationPermissionList;
		}

		return [];
	}

	this.checkWhetherEasyformForwardDetailsExistsOrNot = async function (keyToCheck, postData) {
		let _EasyFormCommonService = this;
		let emrcommonfactory = $injector.get('EMRCommonFactory');

		// CHECKING WHETHER DETAILS ALREADY EXISTS OR NOT
		if (emrcommonfactory.getEHRSettingsInformationForCurrentlyLoggedUsersModuleKey(keyToCheck)) {
			return emrcommonfactory.getEHRSettingsInformationForCurrentlyLoggedUsersBasedOnModuleKey(keyToCheck);
		}

		// ELSE WE NEED TO DO SERVICE CALL FOR GETTING EASY FORM FORWARD DETAILS
		const serviceResponse = await _EasyFormCommonService.htmlTemplatesGetEasyformForwardDetails(postData);

		if (!serviceResponse || isError(serviceResponse)) return;

		// ASSIGNING DATA TO ARRAY
		emrcommonfactory.setEHRSettingsInformationForCurrentlyLoggedUsersBasedOnModuleKey(keyToCheck, serviceResponse);

		return serviceResponse;
	}

}]);



